import { Avatar, Flex, Text } from '@chakra-ui/react'
import { COLORS } from '@ds/tokens/legacy/colors'

import { useTeam } from '@/app/user/api/teams/selectors'
import { useTeamMembers } from '@/common/hooks/useTeamMembers'
import { TEXT_ENUM } from '@/styles/components/text'

// Define a constant for the avatar width
const AVATAR_CONTAINER_WIDTH = '36px'

type Props = {
	isHovered: boolean
	isFullyExpanded: boolean
	onMouseEnter?: () => void
}

export const SidebarHeader = ({
	isHovered,
	isFullyExpanded,
	onMouseEnter,
}: Props) => {
	const team = useTeam()?.team
	const members = useTeamMembers()

	return (
		<Flex
			w="100%"
			position="relative"
			h="32px"
			mt="14px"
			onMouseEnter={onMouseEnter}
		>
			{/* Fixed position avatar container */}
			<Flex
				position="absolute"
				left="2px"
				top="0"
				w={AVATAR_CONTAINER_WIDTH}
				h="32px"
				alignItems="center"
				justifyContent="center"
			>
				<Avatar
					h="32px"
					w="32px"
					src={team?.icon || ''}
					name={team?.name || ''}
				/>
			</Flex>

			{isHovered && isFullyExpanded && (
				<Flex
					h="100%"
					alignItems="center"
					ml={`calc(${AVATAR_CONTAINER_WIDTH} + 12px)`} // Avatar width + gap
					opacity={1}
					transition="opacity 250ms ease-in-out"
					animation="fadeIn 250ms ease-in-out"
					sx={{
						'@keyframes fadeIn': {
							'0%': { opacity: 0 },
							'100%': { opacity: 1 },
						},
					}}
				>
					<Flex flexDir="column">
						<Text variant={TEXT_ENUM.medium14}>{team?.name} </Text>
						<Text
							variant={TEXT_ENUM.regular12}
							color={COLORS.gray[9]}
							overflow="visible"
							textOverflow="clip"
							noOfLines={1}
						>
							{members?.length || 'Loading'} members
						</Text>
					</Flex>
				</Flex>
			)}
		</Flex>
	)
}
